import * as types from "../constants/actionTypes";
import initialState from "./initialState";

export const domainUrlReducer = (state = null, action) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload && action.payload.domainUrl;
    default:
      return state;
  }
};

export const enableAddonsPopUpReducer = (
  state = initialState.enableAddonsPopUp,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload && action.payload.enableAddonsPopUp != null
        ? action.payload.enableAddonsPopUp
        : state;

    default:
      return state;
  }
};

export const enableAddonsRegistrationReducer = (
  state = initialState.enableAddonsRegistration,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload && action.payload.enableAddonsRegistration != null
        ? action.payload.enableAddonsRegistration
        : state;

    default:
      return state;
  }
};

export const showCartSubmitBtnReducer = (state = false, action) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload && action.payload.showCartSubmitBtn != null
        ? action.payload.showCartSubmitBtn
        : false;
    default:
      return state;
  }
};

export const chainHotelsReducer = (
  state = initialState.chainHotels,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload && action.payload.chainHotels != null
        ? action.payload.chainHotels
        : initialState.chainHotels;
    default:
      return state;
  }
};

export const lastMinuteDaysDealReducer = (
  state = initialState.lastMinuteDaysDeal,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS: {
      return action.payload && action.payload.lastMinuteDaysDeal != null
        ? action.payload.lastMinuteDaysDeal
        : state;
    }

    default:
      return state;
  }
};

export const showHotDealReducer = (
  state = initialState.showHotDeal,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS: {
      if (action.payload && action.payload.showHotDeal != null) {
        return action.payload.showHotDeal;
      } else {
        return state;
      }
    }

    default:
      return state;
  }
};

export const discountClubConfigReducer = (
  state = initialState.discountClubConfig,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS: {
      const { discountClubConfig } = action.payload;
      return discountClubConfig || initialState.discountClubConfig;
    }
    default:
      return state;
  }
};

export const hotelDataReducer = (state = initialState.hotelData, action) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload.hotelData;

    default:
      return state;
  }
};

export const sortRatesByDefaultReducer = (state = false, action) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload.sortRatesByLowestPrice;

    default:
      return state;
  }
};

export const showContactDetailsInRegistrationReducer = (
  state = initialState.showContactDetailsInRegistration,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS: {
      return action.payload &&
        action.payload.showContactDetailsInRegistration != null
        ? action.payload.showContactDetailsInRegistration
        : state;
    }

    default:
      return state;
  }
};

export const registrationModelReducer = (state = [], action) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS: {
      const registrationModel = action.payload.registrationModel;
      const filteredRegistrationModel = [];
      for (const key in registrationModel) {
        if (registrationModel[key].visible) {
          filteredRegistrationModel.push({
            ...registrationModel[key],
            name: key
          });
        }
      }
      return filteredRegistrationModel;
    }

    default:
      return state;
  }
};

export const registrationModelContactReducer = (state = [], action) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS: {
      const registrationModel = action.payload.registrationModelContact;
      const filteredRegistrationModel = [];
      for (const key in registrationModel) {
        if (registrationModel[key].visible) {
          filteredRegistrationModel.push({
            ...registrationModel[key],
            name: key
          });
        }
      }
      return filteredRegistrationModel;
    }

    default:
      return state;
  }
};

export const showThumbnailDisplayReducer = (
  state = initialState.ShowThumbnailDisplay,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS: {
      const { ShowThumbnailDisplay } = action.payload;
      return ShowThumbnailDisplay != null
        ? ShowThumbnailDisplay
        : initialState.ShowThumbnailDisplay;
    }
    default:
      return state;
  }
};

export const numRoomsToSwitchToThumnailDisplayReducer = (
  state = initialState.numRoomsToSwitchToThumnailDisplay,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS: {
      const { numRoomsToSwitchToThumnailDisplay } = action.payload;
      return (
        numRoomsToSwitchToThumnailDisplay ||
        initialState.numRoomsToSwitchToThumnailDisplay
      );
    }
    default:
      return state;
  }
};

export const serverConfigReducer = (state = initialState.config, action) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS: {
      return {
        ...state,
        received: true
      };
    }
    case types.CONFIG_FAIL: {
      return {
        ...state,
        received: false
      };
    }
    default:
      return state;
  }
};

export const showAvailabilityReducer = (
  state = initialState.showAvailability,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload.showAvailability;
    default:
      return state;
  }
};

export const lowAvailabilityCountReducer = (
  state = initialState.lowAvailabilityCount,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload.lowAvailabilityCount;
    default:
      return state;
  }
};

export const ShowCancellationPolicyReducer = (
  state = initialState.ShowCancellationPolicy,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload.ShowCancellationPolicy;
    default:
      return state;
  }
};

export const titlesReducer = (state = initialState.titles, action) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload.titles;

    default:
      return state;
  }
};

export const termsAndConditionsReducer = (
  state = initialState.termsAndConditions,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return (
        action.payload.termsAndConditions || initialState.termsAndConditions
      );
    default:
      return state;
  }
};

export const singlePaxCartSkippingReducer = (
  state = initialState.enableSinglePaxCartSkipping,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload.enableSinglePaxCartSkipping;

    default:
      return state;
  }
};

export const propertyTypeReducer = (
  state = initialState.propertyType,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload.propertyType;

    default:
      return state;
  }
};

export const propertyTypePluralReducer = (
  state = initialState.propertyTypePlural,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload.propertyTypePlural;

    default:
      return state;
  }
};

export const allwayShowInRoomUnderRoomDisplayReducer = (
  state = initialState.allwayShowInRoomUnderRoomDisplay,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload.allwayShowInRoomUnderRoomDisplay;

    default:
      return state;
  }
};

export const bookingRatesReducer = (
  state = initialState.bookingRates,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload.bookingRates || state;
    default:
      return state;
  }
};

export const isNoPaymentReducer = (
  state = initialState.isNoPayment,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return action.payload && action.payload.isNoPayment != null
        ? action.payload.isNoPayment
        : false;
    default:
      return state;
  }
};

export const bookingRatesEnabledReducer = (
  state = initialState.bookingRatesEnabled,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return false; //action.payload.bookingRatesEnabled;
    default:
      return state;
  }
};

export const ShowViewExpandedByDefaultReducer = (
  state = initialState.ShowViewExpandedByDefault,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS: {
      return action.payload.ShowViewExpandedByDefault;
    }
    default:
      return state;
  }
};

export const DisplayPriceWithoutTaxesReducer = (
  state = initialState.displayPriceWithoutTaxes,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS: {
      return action.payload.displayPriceWithoutTaxes;
    }
    default:
      return state;
  }
};

export const TaxesPrecentageReducer = (
  state = initialState.taxesPrecentage,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS: {
      return action.payload.taxesPrecentage;
    }
    default:
      return state;
  }
};

export const showPricePerNightThumbReducer = (
  state = initialState.showPricePerNightThumb,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS: {
      return action.payload.showPricePerNightThumb;
    }
    default:
      return state;
  }
};

export const excludedTaxAtHotelReducer = (
  state = initialState.excludedTaxAtHotel,
  action
) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS: {
      return action.payload.excludedTaxAtHotel;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/configReducer.js